import React from 'react'
import './footer.css';
import { Menu } from '../Menu/Menu';
import inditechlogo from '../../assets/Core/logo.png';
import { socialMedia,socialMediaData} from '../SocialMedia';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Footer = () => {
  return (
    <div className='footer-main'>
      <div className='footer-vertical-core'>
        <div className='footer-vertical-container'>
          <img className='footer-logo' src={inditechlogo} alt=''/>
          <div className='footer-info-container'>
            <h2 className="footer-vertical-heading">Address</h2>
              <p>
                302 Sulabh Shanti, Apartments, Ellisbridge, Ahmedabad, 
                <br />
                Ahmadabad City, Gujarat, India, 380006
              </p>
            <iframe title="maps" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d117494.5972529316!2d72.5605774!3d23.0345586!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e85001fa6ff89%3A0xc54fdfe162b63af6!2sSulabhshanti%20Apartment!5e0!3m2!1sen!2sin!4v1759001219305!5m2!1sen!2sin" width="100%" height="150" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>
        {/* <div className='footer-vertical-container'>
          <div className='footer-info-container'>
              <h2 className='footer-vertical-heading'>Services</h2>
              <Menu/>
          </div>
        </div> */}

        <div className='footer-vertical-container'>
          <div className='footer-info-container'>
            <h2 className='footer-vertical-heading'>Quick Links</h2>
            <Menu/>
            <div className='footer-socialedia-icon-container'>
              {Object.entries(socialMedia).map(([platform, link], index) => {
                const socialMediaIcon = socialMediaData[platform];
                return (
                    <a key={index} href={link} target='_blank' rel="noopener noreferrer" >
                        <FontAwesomeIcon className="logos" icon={socialMediaIcon} />
                    </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <hr className='footer-hr' />
      <p className='footer-bottom-text'>© 2024 Copyrights by VyskaTech. All Rights Reserved. Developed by Karan Kumar Agrawal</p>
    </div>
      
    
    
  )
}

export default Footer